<template>
  <div>
    <!-- Non-transactional receipt types (G, K, O) - v-row layout -->
    <v-row
      v-if="
        paymentType.value !== 'T' &&
        paymentType.value !== 'P' &&
        paymentType.value !== 'V'
      "
      dense
    >
      <v-col class="pb-3" cols="3">
        <label class="datepickerLabel">{{ invoiceDateLabel }}</label>
        <date-picker
          :clearable="false"
          prefix-class="xmx"
          :append-to-body="false"
          class="datetimepicker"
          :disabled="datePickersDisabled"
          :value="normalizedInvoiceDate"
          @input="$emit('update:invoiceDate', $event)"
          type="datetime"
          valueType="timestamp"
          :placeholder="invoiceDateLabel"
          format="DD.MM.YYYY HH:mm:ss"
          :default-value="new Date()"
          :popup-style="{
            top: '-274px',
          }"
        ></date-picker>
      </v-col>
      <v-col class="pb-3" cols="3">
        <label class="datepickerLabel">{{ valueDateLabel }}</label>
        <date-picker
          :clearable="false"
          prefix-class="xmx"
          :append-to-body="false"
          class="datetimepicker"
          :disabled="datePickersDisabled"
          :value="normalizedValueDate"
          @input="$emit('update:valueDate', $event)"
          type="datetime"
          valueType="timestamp"
          :placeholder="valueDateLabel"
          format="DD.MM.YYYY HH:mm:ss"
          :default-value="new Date()"
          :popup-style="{
            top: '-274px',
          }"
        ></date-picker>
      </v-col>
      <v-col class="pb-3" cols="3">
        <label class="datepickerLabel">{{ deliveryDateLabel }}</label>
        <date-picker
          :clearable="false"
          prefix-class="xmx"
          :append-to-body="false"
          class="datetimepicker"
          :disabled="false"
          :value="normalizedDeliveryDate"
          @input="$emit('update:deliveryDate', $event)"
          type="datetime"
          valueType="timestamp"
          :placeholder="deliveryDateLabel"
          format="DD.MM.YYYY HH:mm:ss"
          :default-value="new Date()"
          :popup-style="{
            top: '-274px',
          }"
        ></date-picker>
      </v-col>
      <v-col class="pb-3" cols="3">
        <label class="datepickerLabel">Jezik računa</label>
        <v-select
          style="max-height: 34px !important"
          :value="selectedLanguage"
          @input="$emit('update:selectedLanguage', $event)"
          :items="languages"
          outlined
          dense
          item-text="name"
          item-value="value"
          required
          return-object
          hide-details
        ></v-select>
      </v-col>
    </v-row>

    <!-- Transactional receipt types (T, P, V) - flexbox layout -->
    <v-row
      v-if="
        paymentType.value === 'T' ||
        paymentType.value === 'P' ||
        paymentType.value === 'V'
      "
      class="pb-3"
      dense
    >
      <div
        class="pl-1 pt-1"
        :style="tabMode ? 'max-width: 22% !important; min-width: 22% !important' : 'flex: 1; padding-right: 4px;'"
      >
        <label class="datepickerLabel">{{ invoiceDateLabel }}</label>
        <date-picker
          :clearable="false"
          prefix-class="xmx"
          :append-to-body="false"
          class="datetimepicker"
          :disabled="datePickersDisabled"
          :value="normalizedInvoiceDate"
          @input="$emit('update:invoiceDate', $event)"
          type="datetime"
          valueType="timestamp"
          :placeholder="invoiceDateLabel"
          format="DD.MM.YYYY HH:mm:ss"
          :default-value="new Date()"
          :popup-style="{
            top: '-274px',
          }"
        ></date-picker>
      </div>
      <div
        class="pl-1 pt-1"
        :style="tabMode ? 'max-width: 14% !important; min-width: 15% !important' : 'flex: 0.7; padding-right: 4px;'"
      >
        <label class="datepickerLabel">Rok plaćanja (dani)</label>
        <v-combobox
          style="max-height: 34px !important"
          :value="selectedPaymentDue"
          @input="$emit('update:selectedPaymentDue', Number($event) || 0)"
          :items="paymentDues"
          outlined
          dense
          hide-details
          @change="$emit('update-value-date')"
          type="number"
        ></v-combobox>
      </div>
      <div
        class="pl-1 pt-1"
        :style="tabMode ? 'max-width: 22% !important; min-width: 22% !important' : 'flex: 1; padding-right: 4px;'"
      >
        <label class="datepickerLabel">{{ valueDateLabel }}</label>
        <date-picker
          :clearable="false"
          prefix-class="xmx"
          :append-to-body="false"
          class="datetimepicker"
          :disabled="false"
          :value="normalizedValueDate"
          @input="$emit('update:valueDate', $event)"
          type="datetime"
          valueType="timestamp"
          :placeholder="valueDateLabel"
          format="DD.MM.YYYY HH:mm:ss"
          :default-value="new Date()"
          :popup-style="{
            top: '-274px',
          }"
        ></date-picker>
      </div>
      <div
        class="pl-1 pt-1"
        :style="tabMode ? 'max-width: 22% !important; min-width: 22% !important' : 'flex: 1; padding-right: 4px;'"
      >
        <label class="datepickerLabel">{{ deliveryDateLabel }}</label>
        <date-picker
          :clearable="false"
          prefix-class="xmx"
          :append-to-body="false"
          class="datetimepicker"
          :disabled="false"
          :value="normalizedDeliveryDate"
          @input="$emit('update:deliveryDate', $event)"
          type="datetime"
          valueType="timestamp"
          :placeholder="deliveryDateLabel"
          format="DD.MM.YYYY HH:mm:ss"
          :default-value="new Date()"
          :popup-style="{
            top: '-274px',
          }"
        ></date-picker>
      </div>
      <div
        class="pl-1 pt-1 pr-0"
        :style="tabMode ? 'max-width: 18% !important; min-width: 18% !important' : 'flex: 0.8;'"
      >
        <label class="datepickerLabel">Jezik računa</label>
        <v-select
          style="max-height: 34px !important"
          :value="selectedLanguage"
          @input="$emit('update:selectedLanguage', $event)"
          :items="languages"
          outlined
          dense
          item-text="name"
          item-value="value"
          required
          return-object
          hide-details
        ></v-select>
      </div>
    </v-row>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/hr.js'

export default {
  name: 'DateFieldsSection',
  components: {
    DatePicker
  },
  props: {
    paymentType: {
      type: Object,
      required: true
    },
    invoiceDate: {
      type: [Number, String],
      required: true
    },
    valueDate: {
      type: [Number, String],
      required: true
    },
    deliveryDate: {
      type: [Number, String],
      required: true
    },
    invoiceDateLabel: {
      type: String,
      required: true
    },
    valueDateLabel: {
      type: String,
      required: true
    },
    deliveryDateLabel: {
      type: String,
      required: true
    },
    datePickersDisabled: {
      type: Boolean,
      default: false
    },
    selectedPaymentDue: {
      type: Number,
      required: true
    },
    paymentDues: {
      type: Array,
      required: true
    },
    selectedLanguage: {
      type: Object,
      required: true
    },
    languages: {
      type: Array,
      required: true
    },
    tabMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    normalizedInvoiceDate () {
      return typeof this.invoiceDate === 'string' ? new Date(this.invoiceDate).getTime() : this.invoiceDate
    },
    normalizedValueDate () {
      return typeof this.valueDate === 'string' ? new Date(this.valueDate).getTime() : this.valueDate
    },
    normalizedDeliveryDate () {
      return typeof this.deliveryDate === 'string' ? new Date(this.deliveryDate).getTime() : this.deliveryDate
    }
  }
}
</script>

<style scoped>
.datetimepicker {
  width: 100%;
  height: 40px !important;
}

.datepickerLabel {
  font-size: 12px !important;
  font-weight: bold;
}
</style>
